/* eslint-disable no-console */
import * as firebase from 'firebase/app'
import 'firebase/messaging'
import api from '@/api'
import { getUserDisplayName } from '@/utils/helpers'
import User from '@/models/User'
import { TYPE_NAME } from '@/models/Message'
import router from '@/router'
import i18n from '@/i18n'
import store from '@/store'
import { EMOJI } from '@/helpers/variables/index'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)

let messaging = null
if (firebase.messaging.isSupported()) {
  messaging = firebase.messaging()
  messaging.usePublicVapidKey(process.env.VUE_APP_FIREBASE_PUBLIC_VAPID_KEY)
  messaging.onMessage(payload => {
    if (payload.data.type === '1') {
      const message = JSON.parse(payload.data.payload)
      if (store.getters['auth/isLogged'] && store.getters['auth/user'].id === message.sender_id) return
      if (router.currentRoute.name === 'app-chat' && message.chatId === store.state.entities.chats.activeChatId) return
      // const chatSettings = ChatSettings.find(message.chatId)
      // if (chatSettings && !chatSettings.enableNotifications) return
      const user = User.find(message.sender_id)
      const title = user ? getUserDisplayName(user) : message.sender_id
      const bodyByType = {
        contact: `${EMOJI.contact} ${i18n.t('messageType.contact')}`,
        giphy: `${EMOJI.giphy} ${i18n.t('messageType.giphy')}`,
        attachment: `${EMOJI.attachment} ${message.payload || i18n.t('messageType.attachment')}`
      }
      const typeName = TYPE_NAME[message.type]
      if (typeName === 'call') return
      const notificationOptions = {
        body: bodyByType[typeName] || message.payload,
        icon: '/img/hola-icon.png'
      }
      const notification = new Notification(title, notificationOptions)
      notification.onclick = event => {
        event.preventDefault()
        window.focus()
        router.push({ name: 'app-chat', query: { id: window.btoa(message.chat_id) } }).catch(e => {})
      }
    } else if (payload.data.type === '5') {
      store.dispatch('affiliate/fetch')
      const notification = new Notification('You have new member in affiliate tree', {
        icon: '/img/hola-icon.png'
      })
      notification.onclick = event => {
        event.preventDefault()
        window.focus()
        router.push({ name: 'payments-commissions' }).catch(e => {})
      }
    }
  })
  // Callback fired if Instance ID token is updated.
  messaging.onTokenRefresh(async () => {
    try {
      const token = await messaging.getToken()
      await api.push.deviceToken(token)
    } catch (e) {
      console.log('Unable to retrieve refreshed token ', e)
    }
  })
}

let isInited = false

export default async () => {
  if (!messaging || isInited) return
  try {
    await messaging.requestPermission()
    const token = await messaging.getToken()
    await api.push.deviceToken(token)
  } catch (e) {
    console.log('An error occurred while retrieving token. ', e)
  }
  isInited = true
}
